/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";

import { useToast } from "@chakra-ui/react";

export default function LicenseExpiryToast() {
  const [showLicenseWarning, setShowLicenseWarning] = useState(true);
  const [licenseWarning, setLicenseWarning] = useState("");
  const [prevLicenseWarning, setPrevLicenseWarning] = useState("");
  const toast = useToast();
  const toastId = "license-expiry-toast"; // Prevents duplicate toasts
  let debounceHandler = null;

  useEffect(() => {
    const updateWarning = (payload) => {
      debounceHandler = setTimeout(() => {
        if (!payload?.detail?.message) {
          setShowLicenseWarning(false);
          setLicenseWarning("");
        } else if (
          payload?.detail?.message &&
          payload?.detail?.message !== prevLicenseWarning &&
          !showLicenseWarning
        ) {
          setShowLicenseWarning(true);
        }
        setLicenseWarning(payload.detail.message);
        setPrevLicenseWarning(payload.detail.message);
      }, 1000);
    };

    window.addEventListener("licenseWarning", updateWarning);
    return () => {
      window.removeEventListener("licenseWarning", updateWarning);
      clearTimeout(debounceHandler);
      debounceHandler = null;
    };
  });
  useEffect(() => {
    if (licenseWarning && showLicenseWarning) {
      showWarningToast();
    }
  }, [licenseWarning, showLicenseWarning]);

  const handleToastClose = () => {
    setShowLicenseWarning(false);
  };
  const showWarningToast = () => {
    if (!licenseWarning || !showLicenseWarning) return;

    const warning = licenseWarning.split(":");
    const title = warning.length > 1 ? warning[0] : "License Expiring Soon";
    const description = warning.length > 1 ? warning[1] : warning[0];
    const isExpired = licenseWarning.includes("License Expired");

    // Define the configuration dynamically based on the warning type
    const toastConfig = {
      title,
      description,
      status: isExpired ? "error" : "warning",
      position: isExpired ? "bottom-right" : "top-right",
      duration: null,
      isClosable: !isExpired,
      variant: isExpired ? "solid" : "subtle",
      onCloseComplete: isExpired ? undefined : handleToastClose,
    };

    // 1. IF THE TOAST IS ALREADY ACTIVE -> UPDATE IT
    if (toast.isActive(toastId)) {
      toast.update(toastId, toastConfig);
    }
    // 2. IF THE TOAST DOES NOT EXIST -> CREATE IT
    else {
      toast({
        id: toastId,
        ...toastConfig,
      });
    }
  };
  return <div />;
}
